/**
 * @generated SignedSource<<926e2e169525a0ce87feea45f567f638>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignSeriesLayout_viewer$data = {
  readonly iconicDesignSeriesPage: {
    readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesBreadcrumbs_iconicDesignSeriesPage" | "DesignSeriesCollection_iconicDesignSeriesPage" | "DesignSeriesCreator_iconicDesignSeriesPage" | "DesignSeriesEditorial_iconicDesignSeriesPage" | "DesignSeriesHero_iconicDesignSeriesPage">;
  } | null;
  readonly isWordpressArticlesEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesCreator_viewer">;
  readonly " $fragmentType": "DesignSeriesLayout_viewer";
};
export type DesignSeriesLayout_viewer$key = {
  readonly " $data"?: DesignSeriesLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "designSeriesName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignSeriesLayout_viewer",
  "selections": [
    {
      "alias": "isWordpressArticlesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "WP_EDITORIAL"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DesignSeriesCreator_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "designSeriesName",
          "variableName": "designSeriesName"
        }
      ],
      "concreteType": "IconicDesignSeriesPage",
      "kind": "LinkedField",
      "name": "iconicDesignSeriesPage",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DesignSeriesCollection_iconicDesignSeriesPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DesignSeriesBreadcrumbs_iconicDesignSeriesPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DesignSeriesHero_iconicDesignSeriesPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DesignSeriesCreator_iconicDesignSeriesPage"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DesignSeriesEditorial_iconicDesignSeriesPage"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6efbd2a8b654b3fbb77ab3a7c3210dd7";

export default node;
